import { gql } from '@apollo/client';

export const UPDATE_IS_BANNED_MODERATED_AT = gql`
  mutation updateUserBanModeratedMutation($userId: ID!, $isBannedModeratedAt: Boolean!) {
    updateUserBanModerated(userId: $userId, isBannedModeratedAt: $isBannedModeratedAt) {
      void
    }
  }
`;
